import React from 'react';
import {
  InfoText, InfoTextIcon, Section, SectionBody, SectionTitle,
} from './edit-position-preferences-section.styled';
import { EditPositionPreferencesSectionProps } from './edit-position-preferences-section';

export const EditPositionPreferencesSection = ({
  emoji,
  title,
  infoText,
  children,
}: EditPositionPreferencesSectionProps): JSX.Element => {
  return (
    <Section>
      <SectionTitle>
        <span>{emoji}</span>
        {title}
      </SectionTitle>
      { infoText && (
        <InfoText><InfoTextIcon />{ infoText }</InfoText>
      ) }
      <SectionBody>
        {children}
      </SectionBody>
    </Section>
  );
};
